<div class="modal-header">
	<h4 class="modal-title">{{errorTitle}}</h4>
	<button type="button" class="close" aria-label="Close" (click)="cancel()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body">
	<p [innerHtml]="errorBody"></p>

	<p>{{errorStack}}</p>
</div>